export default __webpack_public_path__ + "static/media/calender.0c12863d.svg";